import { compress } from "image-conversion";
import { batch } from "react-redux";
import { 
  setActiveReport, 
  setReportAnswers, 
  setReportGeneratedFlag
} from "../actions/inspections";
import localforage from 'localforage';
import api from "../actions/api";

export const dispatchBatchActions = (dispatch, generateReport) => {
    batch(() => {
        dispatch(setActiveReport(null));
        dispatch(setReportAnswers(null));

        if (generateReport) {
            dispatch(setReportGeneratedFlag(true));
        }
    });
}

/**
 * Compresses an image file and returns a base64 encoded string
 *
 * @param {File} image
 * @returns {Promise<String>}
 */
export const compressImage = async (image) => {
    try {
        const compressedBlob = await compress(image, {
            quality: 0.75,
            type: 'image/png',
            orientation: 1,
        });

        const reader = new FileReader();

        return await new Promise((resolve, reject) => {
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(compressedBlob);
        });
    } catch (error) {
        console.error("Error during compression or conversion:", error);
        throw error;
    }
}

/**
 * Checks the status of a job.
 *
 * @async
 * @param {number|string} jobId - The ID of the job to check.
 * @returns {Promise<JobStatus>} The status of the job.
 * @throws {Error} Throws an error if the job status check fails.
 */
export const checkJobStatus = async jobId => {
    try {
        const url = api.jobs.check.replace(':jobId', jobId);
        const response = await window.axios.get(url);

        return response.data;
    } catch (error) {
        console.error('Error checking job status:', error);
        throw error;
    }
}